





















import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomLabel extends ComponentVue {
  @Prop({ type: Boolean, default: false })
  extraSmall!: boolean

  @Prop({ type: Boolean, default: false })
  small!: boolean

  @Prop({ type: Boolean, default: false })
  large!: boolean

  @Prop({ type: Boolean, default: false })
  extraLarge!: boolean

  @Prop({ type: Boolean, default: false })
  bold!: boolean

  @Prop({ type: Boolean, default: false })
  accent!: boolean

  @Prop({ type: Boolean, default: false })
  danger!: boolean

  @Prop({ type: Boolean, default: false })
  white!: boolean

  @Prop({ type: Boolean, default: false })
  primary!: boolean
}
